import { Button, Form, Input, Upload, message } from 'antd'
import './index.less'
import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as SelectSvg } from '../icons/select.svg'
import { useParams } from 'react-router-dom';
import { getGroupsByBuildingUuid } from '@/api/spec-common/group';
import { Group } from '@/commons/interface/speccommon/group';
import { graphicStore } from '@/commons/store/graphic-store';
import { ModelBase } from 'pytha';
import { GroupType } from '@/commons/enums/group';
import { createWorkOrder } from '@/api/work-order';
import { UploadFileContext } from '@/App';
import { FileUploadParam, UploadFileLocale } from 'tncet-common';
import { ReactComponent as DeleteSvg } from '@/commons/icons/info-detail/element/delete.svg'
import { WorkOrderFile } from '@/commons/interface/work-order';

const { TextArea } = Input;

export default function SendWorkPanel() {
    const { projectUuid, buildingUuid } = useParams();
    const [form] = Form.useForm(); // 表单
    const [loading, setLoading] = useState<boolean>(false); // 创建按钮的loading
    const [groups, setGroups] = useState<Group[]>([]); // 组
    const treeRef = useRef<string>('');
    const [uploadFileList, setUploadFileList] = useState([]);   // 上传的文件列表
    const uploadFileContext = useContext(UploadFileContext);
    const [files, setFiles] = useState<WorkOrderFile[]>([]); // 文件
    const [entityUuid, setEntityUuid] = useState<string>(); // 对象uuid
    const [name, setName] = useState<string>(); // 对象名称

    useEffect(() => {
        return () => {
            const editor = graphicStore.extraContext.getCurrentViewEditor();
            if (!!editor) {
                editor.listeners.signals.onSelectChanged.remove(handleSelect);
            }
        }
    }, [])

    useEffect(() => {
        getGroupsByBuildingUuid(projectUuid, buildingUuid).then(res => {
            let data: Group[] = res.data || [];
            data = data?.map(item => {
                item.hidden = true;
                return item;
            })
            setGroups(data);
        })
    }, [buildingUuid])

    const buildPath = (groupIds: string[]) => {
        if (groups?.length === 0) return [];
        let groupMap: { [key: string]: Group } = {};
        // let tree: (Group & { level?: number })[] = [];
        // 构建dict
        groups?.forEach(group => {
            groupMap[group?.uuid] = { ...group, children: [], level: 1 };
        });
        let tree = [];
        // 构建树
        groupIds.forEach(uuid => {
            let group = groupMap[uuid];
            if (group == null) return;
            if (tree.find(item => item.uuid == group.uuid)) return;
            searchParent(group, groupMap, tree);
        })
        return tree;
    };

    const searchParent = (group: Group, groupMap: { [key: string]: Group }, tree: Group[]) => {
        const parent = groupMap[group?.parentUuid];
        if (parent) {
            searchParent(parent, groupMap, tree);
        }
        if (treeRef.current == '') {
            treeRef.current += `${group.name}`
        } else {
            treeRef.current += `>>${group.name}`
        }
        tree.push(group);
    }

    const activeSelect = () => {
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        if (!editor) return;
        // 发送信号，激活
        editor.listeners.signals.onSelectChanged.remove(handleSelect);
        editor.listeners.signals.onSelectChanged.add(handleSelect);
        message.success("请选择图元对象");
    }

    const handleSelect = (selectEntities: ModelBase[]) => {
        if (selectEntities.length === 0 || !selectEntities[0].isSelected) {
            message.warning("请选择对象");
            return;
        }
        const entity = selectEntities[0];
        let obj = buildObj(entity);
        // 只获取第一个对象
        form.setFieldsValue({
            ...obj
        })
        setEntityUuid(entity.uuid);
        setName(obj['name']);
        message.success("选择对象成功");
        const editor = graphicStore.extraContext.getCurrentViewEditor();
        editor.listeners.signals.onSelectChanged.remove(handleSelect);
    }

    const buildObj = (entity: ModelBase) => {
        let obj = {};
        treeRef.current = '';
        buildPath(entity.group[GroupType.GROUP] || []);
        obj['route'] = treeRef.current;
        obj['type'] = entity.type;

        if (entity.type === "ColumnT") {
            // 柱子
            obj['name'] = "立柱";
            obj['function'] = "竖向传力构件";
        } else if (entity.opacity < 1) {
            // 玻璃
            obj['name'] = "玻璃隔断";
            obj['function'] = "维护构件，用于分隔空间";
        } else if (entity.type === "FireHydrantT") {
            // 消火栓
            obj['name'] = "消火栓";
            obj['function'] = "在火灾发生时排除危险，确保人员的安全";
        } else if (entity.type === "TunnelT") {
            // 管道
            obj['name'] = "消防管道";
            obj['function'] = "消防供水";
        } else if (entity.type === "SprayHeadT") {
            // 烟感器
            obj['name'] = "烟感器";
            obj['function'] = "感应到火灾烟雾时自动洒水灭火";
        } else if (entity.type === "FireExtinguisherT") {
            // 灭火器
            obj['name'] = "灭火器";
            obj['function'] = "手持式灭火设备";
        }
        return obj;
    }

    // 完成了创建表单
    const onFinish = (values) => {
        if (loading) return;
        if (values.content == null || values.content.trim().length == 0) {
            message.warning("工单名称不能为空");
            return;
        }
        if (values.name == null || values.name.trim().length == 0) {
            message.warning("对象不能为空");
            return;
        }
        let data = {
            ...values,
            files: files,
            type: name,
            entityUuid: entityUuid,
        }
        createWorkOrder(data).then(res => {
            message.success("创建成功");
            form.resetFields();
            setEntityUuid(null);
            setName(null);
            setFiles([]);
        }).catch(err => {
            message.error("创建失败");
        }).finally(() => {
            setLoading(false);
        })
    }



    /**
     * 上传前置
     * @param file 
     * @param fileList 
     * @returns 
     */
    const beforeUpload = (file, fileList) => {
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    useEffect(() => {
        if (!uploadFileContext.visible && uploadFileList.length > 0) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    const uploadCallbackFn = (uploadFile: FileUploadParam) => {
        return new Promise(resolve => {
            const file: WorkOrderFile = {
                md5: uploadFile.md5,
                name: uploadFile.name,
                suffix: uploadFile.suffix,
                fileSize: uploadFile.fileSize,
                filePath: uploadFile.filePath
            }
            setFiles([...files || [], file]);
            resolve(true);
        })
    }

    // 从文件列表删除
    const deleteFile = (file) => {
        const fileIndex = files.findIndex(f => f.md5 === file.md5);
        if (fileIndex === -1) {
            message.warning("文件不存在")
            return;
        }
        const newFileList = [...files];
        newFileList.splice(fileIndex, 1);
        setFiles(newFileList);
        message.success("文件已删除");
    }



    return (
        <div className="send-work-container">
            <Form
                colon={false}
                form={form}
                autoComplete="off"
                onFinish={onFinish}
            >
                <Form.Item label="工单名称" name="content">
                    <TextArea className="grey-text-input" />
                </Form.Item>
                <Form.Item label="对象" name="name" valuePropName='value'>
                    <Input placeholder='请选择对象' value={name} className="grey-input short" readOnly />
                    <SelectSvg className="select-icon" onClick={activeSelect} />
                </Form.Item>
                <Form.Item label="路径" name="route" >
                    <Input className="grey-input" readOnly />
                </Form.Item>
                <Form.Item label="功能" name="function" >
                    <TextArea className="grey-text-input" readOnly />
                </Form.Item>
                <div className="divider">问题</div>
                <Form.Item label="描述" name="problem" >
                    <TextArea className="grey-text-input" />
                </Form.Item>
                <Form.Item label="任务目标" name="target" >
                    <TextArea className="grey-text-input" />
                </Form.Item>
                <Upload showUploadList={false} beforeUpload={beforeUpload}>上传相关文件</Upload>
                <div className='file-list'>
                    {files?.map((file, index) => {
                        return <div className='file-item'>
                            <div className='item-name ellipsis' key={index}>{file.name}</div>
                            <div className='item-ope'>
                                {/* <PreviewSvg onClick={() => previewFile(file)} /> */}
                                <DeleteSvg onClick={() => deleteFile(file)} />
                            </div>
                        </div>
                    })}
                </div>
                <div className="divider">执行方</div>
                <Form.Item label="完成人" name="executor" >
                    <TextArea className="grey-text-input" />
                </Form.Item>
                <Form.Item label="承接单位" name="undertakingUnit" >
                    <TextArea className="grey-text-input" />
                </Form.Item>
                <div style={{ flex: '1 1 auto' }}></div>
                <Button loading={loading} htmlType="submit" className="send-work-order-btn">创建</Button>
            </Form>
        </div>
    )
}